
const list ="/power/menu/list";
const del ="/power/menu/delete";
const add ="/power/menu/add";
const edit ="/power/menu/edit";  
const getPowerList ="/power/menu/getPowerList";  
export default {
  list,del,add,edit,getPowerList
  }